<template>
    <span>

    <header id="header">
    <div class="container">

      <div id="logo" class="pull-left">
         <b-link class="navbar-brand" to="/acesso">
             <h1 style="display: none">sdfsdf</h1>
        <h5 class="navbar-brand-full" width="50" height="25" alt="SINDH Desaparecidos">ATENDELIBRAS</h5>
      </b-link>
      </div>
    </div>
  </header>

      <main id="main">
        <section id="schedule" class="section-with-bg">
            <br><br><br>
            <div class="container wow fadeInUp">
              <div class="section-header">
              <h2>ATENDE LIBRAS</h2>
              <p style="color: #525252;">Você está acessando um canal de denúncia de violação de Direitos Humanos. Este canal é EXCLUSIVO para pessoas surdas ou com deficiência auditiva usuárias da Língua Brasileira de Sinais - LIBRAS. Ao clicar em "continuar" você declara que é pessoa surda ou com deficiência auditiva. A declaração falsa pode acarretar em penalidades previstas em Lei.</p>
            </div>

                <div class="tab-content row justify-content-center">
                    <div role="tabpanel" aria-label="Video" class="col-lg-11 tab-pane fade show active" id="day-1">
                          <video controls autoplay loop id="video1" style="width: 100%; height: auto; margin:0 auto; frameborder:0;">
                             <source :src="$api1 + '/videos/video-inicial.mp4'" type="video/mp4">
                          </video>
                        <div class="col-lg-6 offset-lg-5 col-md-6 offset-md-6 footer-links">
                           <br>
                          <b-row class="col-lg-6 col-md-6 footer-contact">
                              <b-button href="javascript:history.go(-1)" variant="secondary"><i class="fa fa-mail-reply-all"></i> Voltar</b-button>&nbsp;&nbsp;&nbsp;
                              <b-button @click="redirect" variant="primary">Continuar <i class="fa icon-action-redo"></i></b-button>
                          </b-row>
                        </div>
                    </div>
                </div>
            </div>
        </section>
      </main>

      <footer id="footer">
        <div class="container">
            <div class="copyright"> <strong>ATENDELIBRAS</strong></div>
        </div>
      </footer>

      <a class="back-to-top"><i class="fa fa-angle-up"></i></a>
    </span>
</template>

<script>
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'

export default {
  name: 'SiteTemplate',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
    }
  },
  mounted () {
    $('#barraBrasilCustom').show()
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  methods: {
    redirect: function () {
      this.$router.push('/captcha-externa')
    }
  }
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import 'flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import 'bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import '../../assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/templates/site-externo/SiteTemplate.vue